module.exports = __webpack_public_path__ + "static/media/material-ui.beef2057.svg";